import styles from '../index.module.css'

import React from 'react'
import { MdCheck as CheckIcon } from '@react-icons/all-files/md/MdCheck'
import type { Business } from 'types/public-playlist'
import { Flex, Text, RadioGroup } from 'components/ds'

type Props = {
  business: Business
  isCurrentBusiness: boolean
}

const BusinessList = ({
  business,
  isCurrentBusiness,
}: Props): React.ReactNode => {
  return (
    <label
      className={styles.AddToDiscoModal_BusinessItem}
      data-disabled={isCurrentBusiness || undefined}
    >
      <Flex direction="column" gap="1" flexGrow="1">
        <Text size="2" weight="medium">
          {business.name}
        </Text>
        <Text size="1" color="gray">
          {business.url}
        </Text>
      </Flex>
      {isCurrentBusiness ? (
        <CheckIcon size={16} />
      ) : (
        <RadioGroup.Item value={business.id.toString()} />
      )}
    </label>
  )
}

export default BusinessList
